module.exports = __webpack_public_path__ + "static/img/discountcard_bg.c293108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discountcard_bg.png
// module id = NkQv
// module chunks = 0